import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'postalCode';

const postalCodeService = {
  getRow: (postalCode) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(postalCode)}`,
    });
  },
};
export default postalCodeService;
